<template>
        <div class="contact-form">
            <h3 v-html="$t('message.contact.title')"></h3>
            <p v-html="$t('message.contact.text')"></p>
            <div class="field-wrapper">
                <label for="firstname" v-html="$t('message.contact.firstname')"></label>
                <input placeholder="ex. John" class="form-field" type="text" id="firstname" v-model="form.firstname">
                <div v-if="$page.props.errors.firstname" class="field-error">{{ $page.props.errors.firstname }}</div>
            </div>
            <div class="field-wrapper">
                <label for="lastname" v-html="$t('message.contact.lastname')"></label>
                <input placeholder="ex. Dupont" class="form-field" id="lastname" type="text" v-model="form.lastname">
                <div v-if="$page.props.errors.lastname" class="field-error">{{ $page.props.errors.lastname }}</div>
            </div>
            <div class="field-wrapper">
                <label for="phone" v-html="$t('message.contact.phone')"></label>
                <input :placeholder="$t('message.contact.phone_placeholder')" class="form-field" type="text" id="phone" v-model="form.phone">
                <div v-if="$page.props.errors.phone" class="field-error">{{ $page.props.errors.phone }}</div>
            </div>
            <div class="field-wrapper">
                <label for="email" v-html="$t('message.contact.email')"></label>
                <input class="form-field" type="text" id="email" v-model="form.email">
                <div v-if="$page.props.errors.email" class="field-error">{{ $page.props.errors.email }}</div>
            </div>
            <div class="field-wrapper">
                <label for="subject" v-html="$t('message.contact.subject')"></label>
                <select class="form-field" id="subject" v-model="form.subject">
                    <option value="Account Opening">{{$t('message.contact.subject_account')}}</option>
                    <option value="Question about a product">{{$t('message.contact.subject_product')}}</option>
                    <option value="General info">{{$t('message.contact.subject_info')}}</option>
                    <option value="Other">{{$t('message.contact.subject_other')}}</option>
                </select>
                <div v-if="$page.props.errors.subject" class="field-error">{{ $page.props.errors.subject }}</div>
            </div>
            <div class="field-wrapper">
                <label for="message" v-html="$t('message.contact.message')"></label>
                <textarea placeholder="" class="form-field" id="message" v-model="form.message"></textarea>
                <div v-if="$page.props.errors.message" class="field-error">{{ $page.props.errors.message }}</div>
            </div>
            <button class="button-black form-button" @click.prevent="send"  v-html="$t('message.contact.send')"></button>
        </div>
</template>

<script>
export default {
    props: ['page', 'branche'],
    data() {
        return {
            can_send: true,
            mail_to: null,
            form: {
                lastname: null,
                firstname: null,
                phone: null,
                email: null,
                subject: null,
                message: null,
                type: 'contact',
                lang: this.$page.props.current_locale
            }
        }
    },
    watch:{
        branche(newVal,oldVal){
            this.mail_to = newVal;
        }
    },
    methods: {
        send() {
            if (this.can_send) {
                this.can_send = false;
                this.$inertia.post(this.$route('app.contact.store'),
                    this.form,
                    {
                        preserveScroll: true,
                        preserveState: true,
                        onFinish: () => {
                            this.can_send = true;
                        }
                    }
                )
            }
        }
    }
}
</script>

<style scoped>

</style>
